<div class="registration-container">
  <div class="form-container">
    <div class="form-header">Account Details</div>
    <form [formGroup]="accountForm">
      <div class="form-group">
        <div class="form-field">
          <label for="firstName">First Name</label>
          <input id="firstName" type="text" formControlName="name" />
          <div
            class="error"
            *ngIf="name?.invalid && (name?.dirty || name?.touched)"
          >
            <div *ngIf="name?.errors?.['required']">
              First Name is required.
            </div>
            <div *ngIf="!name?.errors?.['required']">
              First Name is invalid.
            </div>
          </div>
        </div>
        <div class="form-field">
          <label for="lastName">Last Name</label>
          <input id="lastName" type="text" formControlName="last_name" />
          <div
            class="error"
            *ngIf="
              last_name?.invalid && (last_name?.dirty || last_name?.touched)
            "
          >
            <div *ngIf="last_name?.errors?.['required']">
              Last Name is required.
            </div>
            <div *ngIf="!last_name?.errors?.['required']">
              Last Name is invalid.
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="form-field">
          <label for="meter_number">Meter Number</label>
          <input
            id="meter_number"
            type="text"
            formControlName="meter_number"
            readonly
          />
        </div>
        <div class="form-field">
          <label for="connection_number">Connection Number</label>
          <input
            id="connection_number"
            type="text"
            formControlName="connection_number"
          />
          <div
            class="error"
            *ngIf="
              connection_number?.invalid &&
              (connection_number?.dirty || connection_number?.touched)
            "
          >
            <div *ngIf="connection_number?.errors?.['required']">
              Connection number is required.
            </div>
            <div *ngIf="!connection_number?.errors?.['required']">
              Connection number is invalid.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="form-field">
          <label for="utility">Utility / DISCOM</label>
          <input id="utility" type="text" formControlName="utility_name" />
          <div
            class="error"
            *ngIf="
              utility_name?.invalid &&
              (utility_name?.dirty || utility_name?.touched)
            "
          >
            <div *ngIf="utility_name?.errors?.['required']">
              Utility Name is required.
            </div>
            <div *ngIf="!utility_name?.errors?.['required']">
              Utility Name is invalid.
            </div>
          </div>
        </div>
        <div class="form-field">
          <label for="state">State</label>
          <input id="state" type="text" formControlName="state_name" />
          <div
            class="error"
            *ngIf="state?.invalid && (state?.dirty || state?.touched)"
          >
            <div *ngIf="state?.errors?.['required']">State is required.</div>
            <div *ngIf="!state?.errors?.['required']">State is invalid.</div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="form-field">
          <label for="locality">Locality / Area Name</label>
          <input id="locality" type="text" formControlName="locality" />
          <div
            class="error"
            *ngIf="locality?.invalid && (locality?.dirty || locality?.touched)"
          >
            <div *ngIf="locality?.errors?.['required']">
              Locality is required.
            </div>
            <div *ngIf="!locality?.errors?.['required']">
              Locality is invalid.
            </div>
          </div>
        </div>
        <div class="form-field">
          <label for="pin_code">PIN Code</label>
          <input id="pin_code" type="text" formControlName="pin_code" />
          <div
            class="error"
            *ngIf="pin_code?.invalid && (pin_code?.dirty || pin_code?.touched)"
          >
            <div *ngIf="pin_code?.errors?.['required']">
              Pin Code is required.
            </div>
            <div *ngIf="!pin_code?.errors?.['required']">
              Pin Code is invalid.
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="form-field">
          <label for="phone_number">Phone Number</label>
          <input
            id="phone_number"
            type="text"
            formControlName="phone_number"
            readonly
          />
        </div>
        <div class="form-field">
          <label for="customer_id">Customer ID</label>
          <input
            id="customer_id"
            type="text"
            formControlName="customer_id"
            readonly
          />
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="cancel-button" (click)="backToMarket()">
          Back to Home
        </button>
        <button type="button" class="change-button" (click)="onChangeRequest()">
          Change Request
        </button>
      </div>
    </form>
  </div>
</div>
